import { Row, Col, Button } from 'react-bootstrap';
import { TextButton } from 'Components/Button';
import FeaturedCard from './FeaturedCard';
import NewsEventCard from '../Home/NewsEventCard';
import { useEffect, useState } from 'react';
import { filterEvent, newsUpdateInit } from './NewsAndUpdatesAxiosFuncs';
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { useDispatch } from 'react-redux';
import SubscribeModal from 'Components/Public/Footer/SubscribeModal';
//import { NEWS_AND_UPDATES_DATA } from './NewsAndUpdatesData';

const { LeftPageHeader } = require("Components/Public/PageHeader/PageHeader");

const NewsAndUpdates = () => {

  const dispatch = useDispatch();

  const [singleFeaturedCardData, setSingleFeaturedCardData] = useState([]);
  const [multiFeaturedCardData, setMultiFeaturedCardData] = useState([]);
  //const [newsAndUpdatesList, setNewsAndUpdatesList] = useState(NEWS_AND_UPDATES_DATA);
  const [newsAndUpdatesList, setNewsAndUpdatesList] = useState([]);
  const [subscribeModalTab, setSubscribeModalTab] = useState(null);

  // activeTypeKey: "All", "Event", "Announcement"
  const [activeTypeKey, setActiveTypeKey] = useState("All");
  // activeSortKey: "DESC", "ASC"
  const [activeSortKey, setActiveSortKey] = useState("DESC");

  

  // set activeTypeKey & sort newsAndUpdatesList by activeTypeKey
  const handleActiveTypeKey = (typeKey) => {
    setActiveTypeKey(typeKey);
    filterEvent({
      sorting: activeSortKey,
      eventType: typeKey
    }).then((res) => {
      //console.log("handleActiveTypeKey()", res);
      if (res?.data?.status === 1) {
        setNewsAndUpdatesList(res?.data?.data);
      }
    }).catch((err) => {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
    });
  }

  // set activeSortKey & sort newsAndUpdatesList by activeSortKey
  const handleActiveSortKey = (sortKey) => {
    setActiveSortKey(sortKey);
    filterEvent({
      sorting: sortKey,
      eventType: activeTypeKey
    }).then((res) => {
      //console.log("handleActiveTypeKey()", res);
      if (res?.data?.status === 1) {
        setNewsAndUpdatesList(res?.data?.data);
      }
    }).catch((err) => {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
    });
  }

  // initial load to get all news and updates data
  useEffect(() => {
    filterEvent({
      sorting: "DESC",
      eventType: "All"
    }).then((res) => {
      //console.log("filterEvent()", res);
      if (res?.data?.status === 1) {
        setNewsAndUpdatesList(res?.data?.data);
      }
    }).catch((err) => {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });

    });
  }, []);

  // init load for featured section
  useEffect(() => {
    newsUpdateInit().then((res) => {
      //console.log("newsUpdateInit()", res);
      if (res?.data?.status === 1) {
        let featuredData = res.data?.data?.featuredList;



        // set single featured card data
        // if (featuredData && featuredData.length === 1) {
        //   setSingleFeaturedCardData(featuredData);
        // }

        // set multi featured card data
        if (featuredData) {
          let multiData = [];
          for (let i = 0; i < featuredData.length; i += 2) {
            multiData.push(featuredData.slice(i, i + 2));
          }
          setMultiFeaturedCardData(featuredData);
        //   setMultiFeaturedCardData([
            // {
            //     "id": 10,
            //     "type": "Event",
            //     "name": "FHIR Workgroup Meeting",
            //     "desc": "The PSOPPC FHIR Workgroup is a collaborative initiative under Cormac's AHRQ patient safety contract, convening Patient Safety Organizations to advance interoperable adverse event reporting through HL7 FHIR and USCDI alignment. For more information, please contact us at support@psoppc.org.",
            //     "url": null,
            //     "eventTime": "11:00 - 11:50 AM ET",
            //     "eventDate": "July 31st, 2026",
            //     "postedDate": "POSTED JANUARY 01, 2026",
            //     "registrationEndDate": "July 31st",
            //     "regStatus": 1,
            //     "docGroupId": null
            // },
            // {
            //     "id": 11,
            //     "type": "Event",
            //     "name": "FHIR Workgroup Meeting",
            //     "desc": "The PSOPPC FHIR Workgroup is a collaborative initiative under Cormac's AHRQ patient safety contract, convening Patient Safety Organizations to advance interoperable adverse event reporting through HL7 FHIR and USCDI alignment. For more information, please contact us at support@psoppc.org.",
            //     "url": null,
            //     "eventTime": "11:00 - 11:50 AM ET",
            //     "eventDate": "July 10th, 2026",
            //     "postedDate": "POSTED JANUARY 01, 2026",
            //     "registrationEndDate": "July 10th",
            //     "regStatus": 0,
            //     "docGroupId": null
            // }
        // ]);

            
        }
      }
    }).catch((err) => {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
    });
  }, []);

  return (
    <>
      <LeftPageHeader
        subTitle=""
        title="News & Updates"
        intro="New updates and improvements to PSOPPC & the Network of Patient Safety Databases (NPSD)"
        rightContent={
          <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 w-50 justify-content-center mt-2 mb-2">
            <TextButton
              variant={"outline-clear"}
              onClick={() => setSubscribeModalTab('subscribe')}
              content={"Subscribe"}
              className="button-width"
            />
          </div>
        }
      >
      </LeftPageHeader>
      <Col md={11} lg={9} xl={8} className="px-3 px-md-0">
      
      {/* Featured Title */}
      {(singleFeaturedCardData.length > 0 || multiFeaturedCardData.length > 0) ?
        <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 mt-64px mt-md-80px mb-40px">
          {/* place holder of 2 columns to be left aligned with the header */}
          {/* <Col xxl={2}></Col> */}
          <Col className=' text-start news-update-subtitle'>
            <h2 className="">Featured</h2>
          </Col>
        </Row> : null
      }

      {/* Featured Cards*/}
      {/* Featured Card single */}
      {
    //   singleFeaturedCardData.map((item, index) => (
    //     <Row className="d-flex justify-content-center m-0 p-0 g-0 mt-3 featured-content">
    //       {/* <Col xxl={2}></Col> */}
    //       {/* show > lg */}
    //       <Col className='mb-4 ms-lg-4 me-lg-4 ms-xxl-0 me-xxl-0'>
    //         <FeaturedCard
    //           isMultiple={false}
    //           type={item.type}
    //           postedDate={item.postedDate}
    //           eventDate={item.eventDate}
    //           eventTime={item.eventTime}
    //           registrationEndDate={item.registrationEndDate}
    //           isRegistration={item.regStatus}
    //           title={item.name}
    //           desc={item.desc}
    //         ></FeaturedCard>
    //       </Col>
    //       {/* <Col xxl={2}></Col> */}
    //       {/* show < lg */}
    //       <Col xs={11} className='d-block d-lg-none mb-4 ms-lg-4 me-lg-4 ms-xxl-0 me-xxl-0'>
    //         <FeaturedCard
    //           isMultiple={false}
    //           type={item.type}
    //           postedDate={item.postedDate}
    //           eventDate={item.eventDate}
    //           eventTime={item.eventTime}
    //           registrationEndDate={item.registrationEndDate}
    //           isRegistration={item.regStatus}
    //           title={item.name}
    //           desc={item.desc}
    //         ></FeaturedCard>
    //       </Col>
    //     </Row >
    //   ))
      }
    <div className="d-flex flex-column flex-md-row mt-0 mb-80px gap-40px gap-lg-64px">
      {/* Featured Cards multiple */}
      {multiFeaturedCardData.map((item, key) => (
        <div className="d-flex justify-content-center m-0 p-0 g-0 featured-content" >
            
          {/* <Col xxl={2}></Col> */}
          {/* show > lg */}
          {/* <Col className='text-start me-lg-5 ms-lg-4 ms-xxl-0'> */}
            <FeaturedCard
              isMultiple={multiFeaturedCardData.length>1 ? true : false}
              type={item.type}
              postedDate={item.postedDate}
              eventDate={item.eventDate}
              eventTime={item.eventTime}
              registrationEndDate={item.registrationEndDate}
              isRegistration={item.regStatus}
              title={item.name}
              desc={item.desc}
            ></FeaturedCard>
          {/* </Col> */}
          {/* show > lg */}
          {/* <Col className='d-none d-lg-block text-start me-lg-4 me-xxl-0'>
            {item[1] ?
              <FeaturedCard
                isMultiple={true}
                type={item[1].type}
                postedDate={item[1].postedDate}
                eventDate={item[1].eventDate}
                eventTime={item[1].eventTime}
                registrationEndDate={item[1].registrationEndDate}
                isRegistration={item[1].regStatus}
                title={item[1].name}
                desc={item[1].desc}
              ></FeaturedCard> : null}
          </Col> */}
          {/* <Col xxl={2}></Col> */}
          {/* show < lg */}
          {/* <Col xs={11} className='d-block d-lg-none text-start mb-5'>
            <FeaturedCard
              isMultiple={true}
              type={item[0].type}
              postedDate={item[0].postedDate}
              eventDate={item[0].eventDate}
              eventTime={item[0].eventTime}
              registrationEndDate={item[0].registrationEndDate}
              isRegistration={item[0].regStatus}
              title={item[0].name}
              desc={item[0].desc}
            ></FeaturedCard>
          </Col> */}
          {/* show < lg */}
          {/* <Col xs={11} className='d-block d-lg-none text-start'>
            {item[1] ?
              <FeaturedCard
                isMultiple={true}
                type={item[1].type}
                postedDate={item[1].postedDate}
                eventDate={item[1].eventDate}
                eventTime={item[1].eventTime}
                registrationEndDate={item[1].registrationEndDate}
                isRegistration={item[1].regStatus}
                title={item[1].name}
                desc={item[1].desc}
              ></FeaturedCard> : null}
          </Col> */}
        </div >
        
      ))}
      </div>
      {/* All Updates tabs and filters*/}
      < div className="d-flex justify-content-center w-100 m-0 p-0 g-0 mt-0 mb-12px" >
        {/* place holder of 2 columns to be left aligned with the header */}
        {/* < Col xxl={2} ></Col > */}
        {/* <Col className='d-none d-lg-block text-start news-update-subtitle mx-lg-4 mx-xxl-0'>
          <h2>All Updates</h2>
        </Col> */}
        <Col className='text-start news-update-subtitle'>
          <h2 className="">All Updates</h2>
        </Col>
      </div >
      <div className="mb-40px py-20px">
        {/* place holder of 2 columns to be left aligned with the header */}
        {/* <Col xxl={2}></Col> */}
        {/* show > lg */}

          <div className='d-flex justify-content-between flex-wrap gap-16px'>
            <div className='all-updates-tabs d-flex flex-row align-items-center gap-16px flex-wrap'>
              <div className='text'>Filter by:</div>
              <div className="d-flex flex-row align-items-center gap-16px flex-wrap flex-sm-nowrap">
                <Button
                    className='all-updates-tab'
                    active={activeTypeKey === "All"}
                    onClick={() => handleActiveTypeKey("All")}
                >
                    All
                </Button>
                <Button
                    className='all-updates-tab'
                    active={activeTypeKey === "Event"}
                    onClick={() => handleActiveTypeKey("Event")}
                >
                    Events
                </Button>
                <Button
                    className='all-updates-tab'
                    active={activeTypeKey === "Announcement"}
                    onClick={() => handleActiveTypeKey("Announcement")}
                >
                    Announcements
                </Button>
              </div>
            </div>
            <div className='all-updates-filters d-flex flex-row align-items-center gap-16px'>
              <div className='text'>Sort by:</div>
              <div className='filters-background'>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "DESC"}
                  onClick={() => handleActiveSortKey("DESC")}
                >
                  Newest First
                </Button>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "ASC"}
                  onClick={() => handleActiveSortKey("ASC")}
                >
                  Oldest First
                </Button>
              </div>
            </div>
          </div>

        {/* <Col xxl={2}></Col> */}
        {/* show on md and lg */}
        {/* <Col xs={11} className='text-start d-none d-md-block d-lg-none'>
          <div className='d-flex justify-content-between'>
            <div className='d-inline all-updates-tabs'>
              <span className='text me-3'>Filter by:</span>
              <Button
                className='all-updates-tab me-3'
                active={activeTypeKey === "All"}
                onClick={() => handleActiveTypeKey("All")}
              >
                All
              </Button>
              <Button
                className='all-updates-tab me-3'
                active={activeTypeKey === "Event"}
                onClick={() => handleActiveTypeKey("Event")}
              >
                Events
              </Button>
              <Button
                className='all-updates-tab'
                active={activeTypeKey === "Announcement"}
                onClick={() => handleActiveTypeKey("Announcement")}
              >
                Announcements
              </Button>
            </div>
            <div className='d-inline all-updates-filters mt-1'>
              <span className='text me-3'>Sort by:</span>
              <span className='filters-background'>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "DESC"}
                  onClick={() => handleActiveSortKey("DESC")}
                >
                  Newest First
                </Button>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "ASC"}
                  onClick={() => handleActiveSortKey("ASC")}
                >
                  Oldest First
                </Button>
              </span>
            </div>
          </div>
        </Col> */}
        {/* show on xs and sm */}
        {/* <Col xs={11} className='text-start d-block d-md-none'>
          <div className='d-inline all-updates-tabs'>
            <span className='text me-3'>Filter by:</span>
            <Button
              className='all-updates-tab me-3'
              active={activeTypeKey === "All"}
              onClick={() => handleActiveTypeKey("All")}
            >
              All
            </Button>
            <Button
              className='all-updates-tab me-3'
              active={activeTypeKey === "Event"}
              onClick={() => handleActiveTypeKey("Event")}
            >
              Events
            </Button>
            <Button
              className='all-updates-tab'
              active={activeTypeKey === "Announcement"}
              onClick={() => handleActiveTypeKey("Announcement")}
            >
              Announcements
            </Button>
          </div>
        </Col>
        <Col xs={11} className='text-start d-block d-md-none mt-3'>
          <div className='d-inline all-updates-filters'>
            <span className='text me-3'>Sort by:</span>
            <span className='filters-background'>
              <Button
                className='filter me-2'
                active={activeSortKey === "DESC"}
                onClick={() => handleActiveSortKey("DESC")}
              >
                Newest First
              </Button>
              <Button
                className='filter me-2'
                active={activeSortKey === "ASC"}
                onClick={() => handleActiveSortKey("ASC")}
              >
                Oldest First
              </Button>
            </span>
          </div>
        </Col> */}
      </div>
      {/* All Updates Card list */}
      <div className='mx-0 p-0 all-updates d-flex flex-column gap-24px'>
        {
          newsAndUpdatesList.map((item, index) => (
            <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0">
              {/* place holder of 2 columns to be left aligned with the header */}
              {/* <Col xxl={2}></Col> */}
              {/* show > lg */}
              <Col className='text-start news-updates-card-section'>
                <NewsEventCard
                  key={item.type + index}
                  type={item.type}
                  postedDate={item.postedDate}
                  eventDate={item.eventDate}
                  eventTime={item.eventTime}
                  registrationEndDate={item.registrationEndDate}
                  isRegistration={item.regStatus}
                  title={item.name}
                  description={item.desc}
                  docGroupId={item.docGroupId}
                >
                </NewsEventCard>
              </Col>
              {/* <Col xxl={2}></Col> */}
              {/* show < lg */}
              {/* <Col xs={11} className='d-block d-lg-none text-start news-updates-card-section'>
                <NewsEventCard
                  key={item.type + index}
                  type={item.type}
                  postedDate={item.postedDate}
                  eventDate={item.eventDate}
                  eventTime={item.eventTime}
                  registrationEndDate={item.registrationEndDate}
                  isRegistration={item.regStatus}
                  title={item.name}
                  description={item.desc}
                  docGroupId={item.docGroupId}
                >
                </NewsEventCard>
              </Col> */}
            </Row>
          ))
        }
        {
          newsAndUpdatesList.length === 0 ?
            <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 my-3">
              <Col>
                There is no {activeTypeKey}
              </Col>
            </Row>
            : null
        }
      </div>
      <SubscribeModal
        show={subscribeModalTab !== null}
        handleClose={() => setSubscribeModalTab(null)}
        initialTab={subscribeModalTab ?? 'subscribe'}
      />
      </Col>
    </>
  )
}

export default NewsAndUpdates;